import { HttpStatusCode } from "types/types";

import {
  type ContentServiceClientErrorParams,
  type ContentServiceErrorResponse,
} from "./types";

export class ContentServiceClientError extends Error {
  url: string;
  status: HttpStatusCode;
  errorResponse: ContentServiceErrorResponse;

  constructor({ errorResponse, status, url }: ContentServiceClientErrorParams) {
    super(JSON.stringify(errorResponse));
    this.name = "ContentServiceClientError";
    this.status = status;
    this.url = url;
    this.errorResponse = errorResponse;
  }
}
